// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:wght@300;400;700&display=swap);"]);
// Module
exports.push([module.id, ".questionText{font-size:1.1rem}.radio-button{padding-top:.75rem!important;padding-bottom:.75rem!important;height:auto!important;text-align:left;justify-content:start;white-space:normal;display:block;text-transform:none!important}", ""]);
// Exports
module.exports = exports;
